import { Box, Button, FormControl, InputLabel, Select, MenuItem, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
export default function DataBackup() {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                height: { xs: 'auto', sm: '238px' },
                position: 'relative',
                gap: '20px',
                borderRadius: '10px',
                borderWidth: '1px',
                margin: { xs: '0px 10px', sm: '0px 40px' },
                background: '#FFFFFF',
                border: '1px solid #A5DCF3',
                boxShadow: '-2px 2px 5px 0px rgba(0,0,0,0.25)',
                padding: { xs: '15px', sm: '20px' },
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <Box
                sx={{
                    background: '#647490',
                    boxShadow: '-2px 2px 5px 0px rgba(0,0,0,0.25)',
                    color: '#FFFFFF',
                    fontFamily: 'Roboto',
                    borderRadius:"8px",
                    fontWeight: 600,
                    fontSize: { xs: '20px', sm: '24px' },
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    padding: '12px',
                    marginBottom: '20px',
                    textAlign: 'center'
                }}
            >
                {t("dataBackup")}
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'stretch', sm: 'flex-end' },
                    justifyContent: 'space-between',
                    gap: { xs: '15px', sm: '15px' },
                    padding: '10px',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: { xs: '15px', sm: '20px' },
                        flex: 1,
                        width: '100%'
                    }}
                >
                    <Box sx={{ 
                        width: { xs: '100%', sm: '50%' },
                        mb: { xs: '10px', sm: 0 }
                    }}>
                        <InputLabel
                            sx={{
                                fontFamily: 'Roboto',
                                fontWeight: 500,
                                fontSize: { xs: '18px', sm: '20px' },
                                lineHeight: '100%',
                                letterSpacing: '0%',
                                color: '#1F242E',
                                mb: 1
                            }}
                        >
                            {t("organization")}
                        </InputLabel>
                        <FormControl fullWidth>
                            <Select
                                displayEmpty
                                defaultValue=""
                                sx={{
                                    width: '100%',
                                    height: 55,
                                    borderRadius: '16px',
                                    borderWidth: '2px',
                                    padding: '16px 24px',
                                    border: '2px solid #183059'
                                }}
                            >
                                <MenuItem value="">{t("Select organization")}</MenuItem>
                                <MenuItem value="org1">{t("organization")} 1</MenuItem>
                                <MenuItem value="org2">{t("organization")} 2</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <Box sx={{ 
                        width: { xs: '100%', sm: '50%' },
                        mb: { xs: '10px', sm: 0 }
                    }}>
                        <InputLabel
                            sx={{
                                fontFamily: 'Roboto',
                                fontWeight: 500,
                                fontSize: { xs: '18px', sm: '20px' },
                                lineHeight: '100%',
                                letterSpacing: '0%',
                                color: '#1F242E',
                                mb: 1
                            }}
                        >
                            {t("backupDuration")}
                        </InputLabel>
                        <FormControl fullWidth>
                            <Select
                                displayEmpty
                                defaultValue=""
                                sx={{
                                    width: '100%',
                                    height: 55,
                                    borderRadius: '16px',
                                    borderWidth: '2px',
                                    padding: '16px 24px',
                                    border: '2px solid #183059'
                                }}
                            >
                                <MenuItem value="">{t("Select backup duration")}</MenuItem>
                                <MenuItem value="1day">1 {t("Day")}</MenuItem>
                                <MenuItem value="7days">7 {t("Days")}</MenuItem>
                                <MenuItem value="30days">30 {t("Days")}</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Box>

                <Button
                    variant="outlined"
                    sx={{
                        height: 55,
                        width: { xs: '100%', sm: '161px' },
                        borderRadius: "8px",
                        borderWidth: 1,
                        padding: '16px 24px',
                        background: '#F2F2F3',
                        border: '1px solid #414958',
                        color: '#1F242E',
                        fontWeight: 500,
                        textTransform: 'none',
                        mt: { xs: 2, sm: 0 },
                        '&:hover': {
                            background: '#E0E0E1',
                            borderColor: '#2A3140'
                        }
                    }}
                >
                    {t("backupNow")}
                </Button>
            </Box>
        </Box>
    );
}